
import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './EmployeeShowCause.css';
import jsPDF from "jspdf";
import "jspdf-autotable";
import ExcelJS from 'exceljs';
import { selectStyles } from '../../../assets/Styles/selectStyle';
import { toWords } from 'number-to-words';
import fgIdentitySolutions from '../../../assets/Images/fgIdentitySolutions.jpg';

import { getDistrict, getProject, getStates, getLeavesEmployees, getClients, getLeavesEmployeesShowCause } from '../../../services/monthlyAttendanceService';
import { capitalizeFirstLetter, validateEmail, validateMultipleEmails } from '../../../utils/validations';
import { getFilteredApprovedLeavesReport } from '../../../services/leaveService';
import { emailSendShowCause } from '../../../services/resignationService';

const EmployeeShowCause = () => {
    //const empRole = localStorage.getItem('role');
    // const distctLoginUser = localStorage.getItem('districtId');
    //const loggedInDistrictName = localStorage.getItem('districtName');
    //const loggedInStateId = localStorage.getItem('stateId');
    // const loggedInStateName = localStorage.getItem('stateName');
    //const designationName = localStorage.getItem('designationName'); // Get designation from localStorage

    const [state, setState] = useState(3);
    const [district, setDistrict] = useState(null);
    const [districtName, setDistrictName] = useState('');
    const [designation, setDesignation] = useState();
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [contactNumber, setContactNumber] = useState('');
    const [emailId, setEmailId] = useState('');
    const [subject, setSubject] = useState('');
    const [copyto, setCopyTo] = useState('');
    const [empName, setEmpName] = useState('');
    const [content, setContent] = useState('');
    const [attendanceData, setAttendanceData] = useState([]);

    const [employee, setEmployee] = useState(null);
    const [fromDate, setFromDate] = useState("");


    const effectRan = useRef(false);


    const [isFocused, setIsFocused] = useState({
        state: false,
        district: false,
        designation: false,
        fromDate: false,
        employee: false,
        toDate: false,
        clients: false,
        project: false,
    });
    const [errors, setErrors] = useState({});
    const [hasFetched, setHasFetched] = useState(false);


    // Fetching All states but default set  the bihar state in the setState in the useState
    useEffect(() => {
        const fetchStates = async () => {
            try {
                const data = await getStates();
                const options = data.map(item => ({
                    value: item.id,
                    label: capitalizeFirstLetter(item.stateName),
                }));
                setStateOptions(options);

            } catch (error) {
                console.error('Error fetching states:', error);
                setErrors(prev => ({ ...prev, general: 'Failed to load states' }));
            }
        };
        if (!effectRan.current) {
            fetchStates();
        }
        return () => {
            effectRan.current = true;
        }
    }, []);

    // Fetch districts when state changes
    useEffect(() => {
        if (state) {
            const fetchDistricts = async () => {
                try {
                    const data = await getDistrict(state);
                    const allDistricts = data.map(item => ({
                        value: item.districtId,
                        label: item.districtName,
                    }));

                    setDistrictOptions(allDistricts);
                } catch (error) {
                    console.error('Error fetching districts:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load districts' }));
                }
            };
            fetchDistricts();
        } else {
            setDistrictOptions([]);
            setDistrict(null);
        }
    }, [state]);



    // Fetch employees based on the State and District  based on the Employee  set the Employee Details
    useEffect(() => {
        if (state && district) {
            const fetchEmployee = async () => {
                try {
                    const response = await getLeavesEmployeesShowCause(state, district);
                    setEmployeeOptions(
                        response.map(emp => ({
                            value: emp.employeeUniqueId,
                            empName: emp.employeeName,
                            label: `${emp.employeeName}- ${emp.contactNumber}`,
                            designation: emp.designation,
                            employeeId: emp.employeeId,
                            contactNumber: emp.contactNumber,
                            email: emp.email
                        }))
                    );
                } catch (error) {
                    console.error('Error fetching employees:', error);
                    setErrors(prev => ({ ...prev, general: 'Failed to load employees' }));
                }
            };
            fetchEmployee();
        } else {
            setEmployeeOptions([]);
            setEmployee(null);
        }
    }, [state, district]);

    // Clear attendance data when any dropdown changes
    useEffect(() => {
        setAttendanceData([]);
        setHasFetched(false);
    }, [state, district, designation, employee,]);

    const handleInputChange = (selectedOption, field) => {
        const value = selectedOption ? selectedOption.value : null;
        switch (field) {
            case 'state':
                setState(value);
                setDistrict('');

                break;
            case 'district':
                setDistrict(value);
                setDesignation('');
                setEmployee('')
                break;

            case 'employee':
                setEmployee(value);

                if (selectedOption) {
                    const emp = employeeOptions.find(
                        emp => emp.value === selectedOption.value
                    );

                    setDesignation(emp ? emp.designation : '');
                    setEmailId(emp ? emp.email : '');
                    setContactNumber(emp ? emp.contactNumber : '');

                    if (emp) {
                        setEmpName(emp.empName);

                        setContent(prevContent => {
                            if (prevContent.startsWith('Dear ')) {
                                return prevContent.replace(
                                    /^Dear\s+.*?,/,
                                    `Dear ${emp.empName},`
                                );
                            }

                            return `Dear ${emp.empName},\n\n${prevContent}`;
                        });
                    }
                } else {
                    setDesignation('');
                    setEmailId('');
                    setContactNumber('');
                    setEmpName('');
                    setContent('');
                }
                break;

            case 'designation':
                setDesignation(value);
                break;
            case 'contactNumber':
                setContactNumber(value);
                break;
            case 'emailId':
                setEmailId(value);
                break;
            default:
                break;
        }
        setErrors(prev => ({ ...prev, [field]: null }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!state) newErrors.state = 'State is required';
        if (!district) newErrors.district = 'District is required';
        if (!employee) newErrors.employee = 'Employee is required';
        if (copyto && !validateMultipleEmails(copyto)) {
            newErrors.copyto = "Please enter a valid email address";
        }
        if (!subject) newErrors.subject = 'Subject is required';
        if (!copyto) newErrors.copyto = 'Copy To is required';
        if (!content) newErrors.content = 'Content is required';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const submitShowCause = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        const payload = {
            toEmail: emailId,
            subject: subject,
            body: content,
            ccEmails: copyto
                .split(',')
                .map(email => email.trim())
                .filter(email => email !== '')
        }

        try {


            console.log("Sending payload:", payload); // Debug log to verify projectId

            const data = await emailSendShowCause(payload);
            alert("Mail Send Successfully")
            setAttendanceData(data);
            handleClear();
        } catch (error) {
            console.error("Error fetching report data:", error);
            setErrors((prev) => ({
                ...prev,
                general: "Failed to fetch report data",
            }));
            alert("Failed to fetch report data. Please try again.");
        }
    };

    const handleClear = () => {
        setDistrict('');
        setEmployee('');
        setSubject('');
        setCopyTo('');
        setContent('');
        setErrors('');
        setContactNumber('');
        setEmailId('');
        setDesignation('');
    }

    return (
        <div className="showcause-approval-container">
            <div className="showcause-approval-box">
                <h2 className="showcause-approval-heading">Employee Show Cause</h2>
                {errors.general && <div className="error-message">{errors.general}</div>}
                <form onSubmit={submitShowCause}>
                    <div className="showcause-approval-maincontainer">
                        <div className="showcause-approval-container-part">
                            <div className={`showcause-approval-floating-label-container ${isFocused.state || state ? 'float-label' : ''}`}>
                                <Select
                                    name="state"
                                    options={stateOptions}
                                    value={stateOptions.find(opt => opt.value === Number(state)) || null}
                                    onChange={option => handleInputChange(option, 'state')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                                    placeholder=" "
                                    isClearable={true}
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}

                                />
                                <label><span className="required">*</span>State</label>
                                {errors.state && <div className="error-message">{errors.state}</div>}
                            </div>
                        </div>
                        <div className="showcause-approval-container-part">
                            <div className={`showcause-approval-floating-label-container ${isFocused.district || district ? 'float-label' : ''}`}>
                                <Select
                                    name="district"
                                    options={districtOptions}
                                    value={districtOptions.find(opt => opt.value === Number(district)) || null}
                                    onChange={option => handleInputChange(option, 'district')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                                    placeholder=" "
                                    isClearable={true}
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}

                                />
                                <label><span className="required">*</span>District</label>
                                {errors.district && <div className="error-message">{errors.district}</div>}
                            </div>
                        </div>
                    </div>



                    <div className="showcause-approval-maincontainer">
                        <div className="showcause-approval-container-part">
                            <div className={`showcause-approval-floating-label-container ${isFocused.employee || employee ? 'float-label' : ''}`}>
                                <Select
                                    name="employee"
                                    options={employeeOptions}
                                    value={employeeOptions.find(opt => opt.value === employee) || null}
                                    onChange={option => handleInputChange(option, 'employee')}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, employee: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, employee: false }))}
                                    placeholder=" "
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={selectStyles}
                                />
                                <label><span className="required">*</span>Employee Name</label>
                                {errors.employee && <div className="error-message">{errors.employee}</div>}
                            </div>
                        </div>

                        <div className="showcause-approval-container-part">
                            <div className={`showcause-approval-floating-label-container ${isFocused.designation || designation ? 'float-label' : ''}`}>
                                <input
                                    type="text"
                                    name="designation"
                                    value={designation || ""}
                                    onChange={(e) => {
                                        setDesignation(e.target.value);
                                        setErrors(prev => ({ ...prev, designation: null }));
                                    }}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, designation: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, designation: false }))}
                                    placeholder=" "
                                    className="did-floating-input"
                                    readOnly
                                    disabled
                                />
                                <label>Designation</label>
                                {errors.designation && <div className="error-message">{errors.designation}</div>}
                            </div>
                        </div>
                    </div>

                    <div className="showcause-approval-maincontainer">
                        <div className="showcause-approval-container-part">
                            <div className={`showcause-approval-floating-label-container ${isFocused.emailId || emailId ? 'float-label' : ''}`}>
                                <input
                                    type="text"
                                    name="emailId"
                                    value={emailId || ""}
                                    onChange={(e) => {
                                        setEmailId(e.target.value);
                                        setErrors(prev => ({ ...prev, contactNumber: null }));
                                    }}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, contactNumber: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, contactNumber: false }))}
                                    placeholder=" "
                                    className="did-floating-input"
                                    readOnly
                                    disabled
                                />
                                <label>Email Id</label>
                                {/* {errors.contactNumber && <div className="error-message">{errors.contactNumber}</div>} */}
                            </div>
                        </div>

                        <div className="showcause-approval-container-part">
                            <div className={`showcause-approval-floating-label-container ${isFocused.contactNumber || contactNumber ? 'float-label' : ''}`}>
                                <input
                                    type="text"
                                    name="contactNumber"
                                    value={contactNumber || ""}
                                    onChange={(e) => {
                                        setContactNumber(e.target.value);
                                        setErrors(prev => ({ ...prev, contactNumber: null }));
                                    }}
                                    onFocus={() => setIsFocused(prev => ({ ...prev, contactNumber: true }))}
                                    onBlur={() => setIsFocused(prev => ({ ...prev, contactNumber: false }))}
                                    placeholder=" "
                                    className="did-floating-input"
                                    readOnly
                                    disabled
                                />
                                <label>Contact Number</label>
                                {/* {errors.contactNumber && <div className="error-message">{errors.contactNumber}</div>} */}
                            </div>
                        </div>
                    </div>
                    <div className="showcause-approval-maincontainer">
                        <div className="showcause-approval-container-part">
                            <div className={`showcause-approval-floating-label-container ${isFocused.subject || subject ? 'float-label' : ''}`}>
                                <input
                                    type="text"
                                    name="contactNumber"
                                    value={subject || ""}
                                    title={subject}
                                    onChange={(e) => { setSubject(e.target.value) }}
                                    className="did-floating-input text-black fw-normal"

                                />
                                <label><span className="required">*</span>Subject</label>
                                {errors.subject && <div className="error-message">{errors.subject}</div>}
                            </div>
                        </div>

                        <div className="showcause-approval-container-part">
                            <div className={`showcause-approval-floating-label-container ${isFocused.copyto || copyto ? 'float-label' : ''}`}>
                                <input
                                    type="text"
                                    name="copyto"
                                    value={copyto || ""}
                                    title={copyto}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setCopyTo(value);

                                        if (value && !validateMultipleEmails(value)) {
                                            setErrors(prev => ({
                                                ...prev,
                                                copyto: "Please enter a valid email address"
                                            }));
                                        } else {
                                            setErrors(prev => ({
                                                ...prev,
                                                copyto: null
                                            }));
                                        }
                                    }}
                                    className="did-floating-input text-black fw-normal"
                                />
                                <label><span className="required">*</span>Copy to</label>
                                {errors.copyto && (<div className="error-message">{errors.copyto}</div>)}
                            </div>
                        </div>
                    </div>
                    <div className="showcause-approval-maincontainer">
                        <div className="showcause-approval-container-part">
                            <div className={`showcause-approval-floating-label-container ${isFocused.content || content ? 'float-label' : ''}`}>
                                <textarea
                                    value={content}
                                    onChange={(e) => setContent(e.target.value)}
                                    rows={5}
                                    className="did-floating-input text-dark fw-normal"
                                />
                                <label><span className="required">*</span>Content</label>
                                {errors.content && <div className="error-message">{errors.content}</div>}
                            </div>
                        </div>


                    </div>


                    <div className=' d-flex justify-content-center gap-3'>
                        <div >
                            <button type="submit" className="showcause-approval-btn" >
                                Submit
                            </button>
                        </div>
                        <div>
                            <button type="button" className=' showcause-cancel-btn' onClick={handleClear}>Cancel</button>
                        </div>

                    </div>

                </form>
            </div>


        </div>
    );
};

export default EmployeeShowCause;